import { Pie } from "recharts";

const BasePie = Pie

export default BasePie;